// app.actions.ts
import { createAction, props } from '@ngrx/store';

export const undo = createAction('[App] Undo');
export const redo = createAction('[App] Redo');

export const showMessage = createAction(
    '[App] Show Message',
    props<{ message: string }>() // Define the payload type
);
